(function () {
  'use strict';

  var indexPromises = {};
  var vehicleStorageKey = 'oo_selected_vehicle';

  function readVehicle() {
    try {
      var stored = window.localStorage.getItem(vehicleStorageKey);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  }

  function writeVehicle(vehicle) {
    try {
      window.localStorage.setItem(vehicleStorageKey, JSON.stringify(vehicle));
    } catch (error) {
      // Vehicle search still works when storage is unavailable.
    }
  }

  function clearVehicle() {
    try {
      window.localStorage.removeItem(vehicleStorageKey);
    } catch (error) {
      // Ignore storage restrictions.
    }
  }

  function vehicleLabel(vehicle) {
    return [vehicle.year, vehicle.make, vehicle.model, vehicle.engine].filter(Boolean).join(' ');
  }

  function updateVehicleContexts(vehicle, announce) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oo-vehicle-context]'), function (context) {
      var label = context.querySelector('[data-oo-vehicle-label]');
      var shop = context.querySelector('[data-oo-vehicle-shop]');
      var clear = context.querySelector('[data-oo-vehicle-clear]');
      var select = context.querySelector('[data-oo-vehicle-select]');
      var live = context.querySelector('[data-oo-vehicle-announcement]');
      var hasVehicle = Boolean(vehicle && vehicle.year && vehicle.make);
      var text = hasVehicle ? vehicleLabel(vehicle) : 'No vehicle selected';

      if (label) label.textContent = text;
      if (shop) {
        shop.hidden = !hasVehicle;
        if (hasVehicle) shop.href = shop.getAttribute('href').split('?')[0] + '?type=product&q=' + encodeURIComponent(text);
      }
      if (clear) clear.hidden = !hasVehicle;
      if (select) select.textContent = hasVehicle ? 'Change vehicle' : 'Select vehicle';
      if (announce && live) live.textContent = hasVehicle ? 'Selected vehicle: ' + text : 'Selected vehicle cleared.';
    });
  }

  function hydrateVehicleForm(form, vehicle) {
    if (!vehicle) return;
    ['year', 'make', 'model', 'engine'].forEach(function (name) {
      var field = form.querySelector('[name="' + name + '"]');
      if (field && vehicle[name]) field.value = vehicle[name];
    });
  }

  function normalizeOE(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function isLikelyOE(value) {
    var text = String(value || '').trim();
    var normalized = normalizeOE(text);
    var longWords = text.split(/\s+/).filter(function (token) {
      return /^[A-Za-z]{4,}$/.test(token);
    });

    return normalized.length >= 6 &&
      normalized.length <= 24 &&
      /\d/.test(normalized) &&
      /^[A-Za-z0-9\s._/-]+$/.test(text) &&
      longWords.length === 0;
  }

  function loadIndex(url) {
    if (!url) return Promise.resolve({});
    if (!indexPromises[url]) {
      indexPromises[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('OE index unavailable');
          return response.json();
        })
        .catch(function () { return {}; });
    }
    return indexPromises[url];
  }

  function track(eventName, detail) {
    var payload = detail || {};

    if (window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish('olivia_oliver:' + eventName, payload);
      } catch (error) {
        // Analytics must never block catalog search or purchase actions.
      }
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'oo_' + eventName }, payload));
  }

  function searchUrl(form, query) {
    var action = form.getAttribute('action') || '/search';
    return action + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
  }

  function setBusy(form, busy) {
    var button = form.querySelector('[type="submit"]');
    if (!button) return;
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function handleOESubmit(event) {
    var form = event.currentTarget;
    var input = form.querySelector('input[name="q"]');
    var raw = input ? input.value.trim() : '';

    if (!raw || !isLikelyOE(raw)) return;

    event.preventDefault();
    setBusy(form, true);

    var normalized = normalizeOE(raw);
    var source = form.getAttribute('data-search-context') || 'unknown';
    track('oe_search_submitted', {
      oe_query: normalized,
      input_format: raw === normalized ? 'normalized' : 'formatted',
      search_source: source
    });

    loadIndex(form.getAttribute('data-oe-index-url')).then(function (index) {
      var matches = index[normalized] || [];
      if (matches.length === 1) {
        track('oe_search_resolved', {
          oe_query: normalized,
          match_count: 1,
          match_outcome: 'unique',
          search_source: source,
          destination: matches[0].url
        });
        window.location.assign(matches[0].url);
        return;
      }
      track(matches.length ? 'oe_search_resolved' : 'oe_search_no_match', {
        oe_query: normalized,
        match_count: matches.length,
        match_outcome: matches.length ? 'multiple' : 'none',
        search_source: source
      });
      window.location.assign(searchUrl(form, normalized));
    });
  }

  function editDistance(a, b) {
    if (Math.abs(a.length - b.length) > 1) return 2;
    var previous = [];
    var current = [];
    var i;
    var j;

    for (j = 0; j <= b.length; j += 1) previous[j] = j;
    for (i = 1; i <= a.length; i += 1) {
      current[0] = i;
      for (j = 1; j <= b.length; j += 1) {
        current[j] = Math.min(
          current[j - 1] + 1,
          previous[j] + 1,
          previous[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)
        );
      }
      previous = current.slice();
    }
    return previous[b.length];
  }

  function renderSuggestions(container, query, index) {
    var normalized = normalizeOE(query);
    if (!isLikelyOE(query) || index[normalized]) return;

    var candidates = Object.keys(index).filter(function (key) {
      return editDistance(normalized, key) === 1;
    }).slice(0, 3);

    if (!candidates.length) return;

    var heading = document.createElement('p');
    heading.className = 'oo-suggestions__heading';
    heading.textContent = 'Possible OE matches — verify the number before ordering:';
    container.appendChild(heading);

    var list = document.createElement('ul');
    list.className = 'oo-suggestions__list';
    candidates.forEach(function (key) {
      var record = index[key][0];
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = index[key].length === 1 ? record.url : '/search?type=product&q=' + encodeURIComponent(key);
      link.textContent = record.raw + ' — ' + record.title;
      link.addEventListener('click', function () {
        track('oe_possible_match_selected', {
          oe_query: normalized,
          suggested_oe: key,
          candidate_count: index[key].length
        });
      });
      item.appendChild(link);
      list.appendChild(item);
    });
    container.appendChild(list);
  }

  function initVehicleForm(form) {
    hydrateVehicleForm(form, readVehicle());
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var values = Array.prototype.map.call(form.querySelectorAll('select, input[type="text"]'), function (field) {
        return field.value.trim();
      }).filter(Boolean);
      var year = form.querySelector('[name="year"]');
      var make = form.querySelector('[name="make"]');
      if (!year || !year.value || !make || !make.value) {
        var message = form.querySelector('[data-vehicle-message]');
        if (message) {
          message.hidden = false;
          message.focus();
        }
        return;
      }
      var vehicle = {
        year: year.value,
        make: make.value,
        model: form.querySelector('[name="model"]').value.trim(),
        engine: form.querySelector('[name="engine"]').value.trim()
      };
      writeVehicle(vehicle);
      updateVehicleContexts(vehicle, true);
      track('vehicle_search_submitted', {
        vehicle_year: year.value,
        vehicle_make: make.value,
        has_model: Boolean(form.querySelector('[name="model"]').value.trim()),
        has_engine: Boolean(form.querySelector('[name="engine"]').value.trim())
      });
      window.location.assign(searchUrl(form, values.join(' ')));
    });
  }

  function initStickyAddToCart(bar) {
    var mainButton = document.querySelector('[data-add-to-cart]');
    var stickyButton = bar.querySelector('[data-oo-sticky-add]');
    var focusedField = false;
    var mainButtonVisible = false;

    if (!mainButton || !stickyButton) return;

    function updateVisibility() {
      var shouldShow = !focusedField && !mainButtonVisible && !mainButton.disabled &&
        mainButton.getAttribute('aria-disabled') !== 'true';
      bar.hidden = !shouldShow;
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    stickyButton.addEventListener('click', function () {
      track('mobile_sticky_add_selected', {
        product_handle: bar.getAttribute('data-product-handle') || ''
      });
      mainButton.click();
    });

    document.addEventListener('focusin', function (event) {
      focusedField = /^(INPUT|SELECT|TEXTAREA)$/.test(event.target.tagName);
      updateVisibility();
    });
    document.addEventListener('focusout', function () {
      focusedField = false;
      updateVisibility();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        mainButtonVisible = entries[0].isIntersecting;
        updateVisibility();
      }, { threshold: 0.2 });
      observer.observe(mainButton);
    } else {
      updateVisibility();
    }

    if ('MutationObserver' in window) {
      new MutationObserver(updateVisibility).observe(mainButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var selectedVehicle = readVehicle();
    updateVehicleContexts(selectedVehicle, false);
    Array.prototype.forEach.call(document.querySelectorAll('[data-oo-vehicle-clear]'), function (button) {
      button.addEventListener('click', function () {
        clearVehicle();
        updateVehicleContexts(null, true);
        Array.prototype.forEach.call(document.querySelectorAll('[data-oo-vehicle-search]'), function (form) {
          form.reset();
        });
        track('vehicle_selection_cleared', {});
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-oo-oe-search]'), function (form) {
      form.addEventListener('submit', handleOESubmit);
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-oo-vehicle-search]'), initVehicleForm);

    Array.prototype.forEach.call(document.querySelectorAll('[data-oo-fitment-help]'), function (link) {
      link.addEventListener('click', function () {
        track('fitment_help_selected', {
          help_source: link.getAttribute('data-help-context') || 'unknown',
          product_handle: link.getAttribute('data-product-handle') || ''
        });
      });
    });

    var stickyAdd = document.querySelector('[data-oo-sticky-add-bar]');
    if (stickyAdd) initStickyAddToCart(stickyAdd);

    var suggestions = document.querySelector('[data-oe-suggestions]');
    if (suggestions) {
      loadIndex(suggestions.getAttribute('data-oe-index-url')).then(function (index) {
        renderSuggestions(suggestions, suggestions.getAttribute('data-query') || '', index);
      });
    }
  });

  window.OliviaOliverSearch = { normalizeOE: normalizeOE, isLikelyOE: isLikelyOE, track: track };
}());
